import { Box } from '@mui/material';

interface IconBoxProps {
    children: React.ReactNode;
    boxColor: string
    size?: number
    margin?:number
    hoverColor?: string | null
}


const IconBox: React.FC<IconBoxProps> = ({ children, boxColor, size = 42, margin=2, hoverColor=null }) => {
    return <Box sx={{
        display: "flex", 
        backgroundColor: boxColor, 
        justifyContent: "center", 
        alignItems: "center", 
        height: size+5, 
        width: size+5, 
        borderRadius: 1, 
        "& > *": {
            margin: 0,
            padding: 0,
        },
        m:margin,
        '&:hover': { backgroundColor: hoverColor },
    }}>
        {children}
    </Box>

}

export default IconBox;